module.exports = __webpack_public_path__ + "static/img/huodongzhongxin.f5713905.png";